import React, { useContext, useMemo} from 'react';

import { Skeleton } from 'primereact/skeleton';
import { Accordion, AccordionTab } from 'primereact/accordion';

import {firebaseTimestampToMoment} from '../utils/utils'

import classNames from 'classnames';
import AppContext from '../hooks/AppContext'

const BuDetalhe = (props) => {    
 
    const {localidades} = useContext(AppContext);
    
    const getSecao = (dados) =>{
        let listDados = dados.split(" ");
        let secao = listDados.find( item => item.startsWith("SECA:"))
        return secao.split(":")[1]|| "0"
    }
    
    const getZona = (dados) =>{
        let listDados = dados.split(" ");
        let zona = listDados.find( item => item.startsWith("ZONA:"))
        return zona.split(":")[1]|| "0"
    }
    const getMuni = (dados) =>{
        let listDados = dados.split(" ");
        let muni = listDados.find( item => item.startsWith("MUNI:"))
        return muni.split(":")[1]|| "0"
    }


    if(props?.skeleton){
        return (<Skeleton className={"bloco-dados bg-gray-200 flex-wrap secoes"} ></Skeleton> )
    }
    return(                                             
        <div className={"bloco-dados bg-gray-200 flex-wrap secoes"}>
            <div className={"bloco-progesso-title flex-wrap"}>                                        
                <div className={"bloco-title font-bold"}>{"ZE: "+getZona(props?.dados) +" - seção: "+ getSecao(props?.dados)}</div> 
                <div className={"bloco-subtitle align-self-end"}>{
                    props?.resolvido? 
                        <div>
                            {"Resolvida: "} 
                            <i className="pi pi-check-circle mr-2"></i>   
                        </div>
                        :<div>
                            {"Resolvida: "}
                            <i className="pi pi-circle mr-2"></i> 
                        </div>               
                }</div>
            </div>                                                           
            <div>{localidades?.find( localidade => localidade?.sgUe==getMuni(props?.dados))?.nmUe}</div>
            <Accordion activeIndex={0} className="w-full mt-2 mb-2">
                    <AccordionTab header="Dados QRcode">
                        <p style={{wordBreak: 'break-word'}}>{props?.dados}</p>
                    </AccordionTab>
            </Accordion>
            <div className={"ultima-atualizacao-data"}>{"Lido às: "+ firebaseTimestampToMoment(props?.dataHora)}</div>

            
        </div>          
    )
}
export default BuDetalhe;    
